<div class="px-5 py-8 min-w-[250px] max-w-[95vw] sm:max-w-[500px] relative rounded bg-white shadow-lg">
	<div (click)="dialogRef.close()"
		 class="absolute top-0 left-0 px-2 pt-2 bg-[#D4A373] rounded">
			<span class="material-symbols-outlined cursor-pointer text-white">
				close
			</span>
	</div>
	<div class="w-full justify-center items-center flex flex-col">
		<h1 class="text-base md:text-xl p-1 font-medium">Thank You For your interest in this Product</h1>
		<h3 class="text-sm text-[#9fa6b8] p-2 ">We shall notify you as soon as the item is in stock</h3>
		<div class="flex flex-col justify-center items-center my-3 gap-2 text-center w-full">
			<img class="w-[150px] object-contain" [src]="data.product.heroImage" [alt]="data.product.heroImageAlt">
			<h2 class="text-sm">{{data.product.name}}</h2>
		</div>
		<div class="text-base py-2 text-center">Specify the quantity you require with us to help serve you better? </div>
		<input class="p-2 my-2 w-ful border-2 border-[#9fa6b8] rounded" type="number" [(ngModel)]="quantity">

		<div class="flex justify-end items-center gap-0.5 my-1">
			<button (click)="submit()"
					class="secondary-button transition-all  py-1.5 px-5 w-min  flex justify-center items-center rounded-md">Submit</button>
		</div>
	</div>
</div>
